<template>
    <div>
        <el-radio-group v-model="type" size="small">
            <el-radio-button :label="1">红包发放</el-radio-button>
            <el-radio-button :label="2">红包消费</el-radio-button>
        </el-radio-group>
        <redpackage-record-get v-if="type==1" :phone="phone" :userId="userId"></redpackage-record-get>
        <redpackage-record-use v-if="type==2" :phone="phone" :userId="userId"></redpackage-record-use>
    </div>
</template>

<script>
import redpackageRecordGet from './redpackage-record-get.vue'
import RedpackageRecordUse from './redpackage-record-use.vue'
export default {
    components: { redpackageRecordGet, RedpackageRecordUse },
    data() {
        return {
            type: 1
        }
    },
    props:['userId','phone'],
}
</script>

<style lang="scss" scoped>

</style>